import React from 'react';
import PropTypes from "prop-types";

// Components
import CropperModel from './CropperModel';

function FileInput(props) {
  const inputFileRef = React.useRef();

  const [file, setFile] = React.useState(null);
  const [resizedImage, setResizedImage] = React.useState(props.image);

  const { onUpload } = props;

  /** Event: File input change  */
  const onFileInputChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setFile(e.target.files[0]);
    }

    e.target.value = null;
  };

  const uploadFile = (e) => {
    inputFileRef.current.click();
  }

  const deleteFile = (e) => {
    setResizedImage('/images/missing.png');
    props.onRemove();
    // inputFileRef.current.click();
  }

  return (
    <div className="mt-4">
      <div className="text-center mb-4 card">
        <div className="card-body">
          {!!resizedImage && (
            <div className="avatar">
              <div className="card-body">
                <img src={resizedImage} className="img-circle"
                  style={{ height: '100px', width: '100px' }} alt='Cropped Image'/>
              </div>
              <div className="upload-overlay">
                <div>
                  <a onClick={uploadFile}><i className="glyphicon glyphicon-cloud-upload" style={{ color: '#fff' }}></i></a>
                  {props.removeUrl &&
                    <a onClick={deleteFile}>
                      <i className="glyphicon glyphicon-remove" style={{ marginLeft: 5, color: '#fff' }}></i>
                    </a>
                  }
                </div>
              </div>
            </div>
          )}
          <input accept="image/jpeg,image/png" ref={inputFileRef} type="file" className="btn-upload hide" onChange={onFileInputChange} />

          <CropperModel file={file}
            onConfirm={(croppedFile) => {
              setResizedImage(window.URL.createObjectURL(croppedFile));
              onUpload(croppedFile);
            }}
            onCompleted={() => setFile(null)} />
        </div>
      </div>
    </div>
  );
}

FileInput.propsTypes = {
  onUpload: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  image: PropTypes.string,
  removeUrl: PropTypes.string
};

export default FileInput;

